import GenericPasswordChangeForm from "./GenericPasswordChangeForm.vue";
export default GenericPasswordChangeForm;
